import { isAxiosError } from 'axios';

/**
 * Extracts a user-facing error message from an unknown thrown value.
 *
 * Priority:
 *   1. Axios error with a backend `detail` field (FastAPI convention)
 *   2. Generic Error message
 *   3. Caller-supplied fallback string
 */
export function extractErrorMessage(err: unknown, fallback: string): string {
  if (isAxiosError(err)) return err.response?.data?.detail ?? fallback;
  if (err instanceof Error) return err.message;
  return fallback;
}
